import { render } from "./CardSistemaPatrimonio.vue?vue&type=template&id=18766661"
import script from "./CardSistemaPatrimonio.vue?vue&type=script&lang=js"
export * from "./CardSistemaPatrimonio.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/intranet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__